import React from 'react';
import './HostelCreditsCell.css';

function creditCount(value?: number): number {
  const n = Number(value);
  return Number.isFinite(n) ? Math.max(0, Math.floor(n)) : 0;
}

type HostelCreditsCellProps = {
  emailCredits?: number;
  whatsappCredits?: number;
  showEmail?: boolean;
  showWhatsapp?: boolean;
};

const HostelCreditsCell: React.FC<HostelCreditsCellProps> = ({
  emailCredits,
  whatsappCredits,
  showEmail = true,
  showWhatsapp = true,
}) => {
  const email = creditCount(emailCredits);
  const whatsapp = creditCount(whatsappCredits);

  return (
    <div className="hostel-credits-cell">
      {showEmail ? (
        <span
          className={`hostel-credit-pill hostel-credit-pill--email${email > 0 ? '' : ' is-empty'}`}
          title="Email credits"
        >
          <span className="hostel-credit-pill__icon" aria-hidden>
            ✉
          </span>
          {email.toLocaleString('en-IN')}
        </span>
      ) : null}
      {showWhatsapp ? (
        <span
          className={`hostel-credit-pill hostel-credit-pill--wa${whatsapp > 0 ? '' : ' is-empty'}`}
          title="WhatsApp credits"
        >
          <span className="hostel-credit-pill__icon" aria-hidden>
            💬
          </span>
          {whatsapp.toLocaleString('en-IN')}
        </span>
      ) : null}
    </div>
  );
};

export default HostelCreditsCell;
